import React from 'react';

const CALLOUT_MAP = [
  { emoji: '💡', color: '#f59e0b', bg: 'rgba(245,158,11,0.06)', border: 'rgba(245,158,11,0.22)' },
  { emoji: '⚠️', color: '#f97316', bg: 'rgba(249,115,22,0.06)', border: 'rgba(249,115,22,0.22)' },
  { emoji: '✅', color: '#10b981', bg: 'rgba(16,185,129,0.06)',  border: 'rgba(16,185,129,0.22)' },
  { emoji: '❌', color: '#ef4444', bg: 'rgba(239,68,68,0.06)',   border: 'rgba(239,68,68,0.22)' },
  { emoji: '🎯', color: '#818cf8', bg: 'rgba(129,140,248,0.06)', border: 'rgba(129,140,248,0.22)' },
  // Fase 5.5 — Smart Presentation Engine
  { emoji: '📌', color: '#38bdf8', bg: 'rgba(56,189,248,0.06)',  border: 'rgba(56,189,248,0.22)'  },
  { emoji: '🧠', color: '#a78bfa', bg: 'rgba(167,139,250,0.06)', border: 'rgba(167,139,250,0.22)' },
  { emoji: '🚀', color: '#34d399', bg: 'rgba(52,211,153,0.06)',  border: 'rgba(52,211,153,0.22)'  },
  { emoji: '📋', color: '#94a3b8', bg: 'rgba(148,163,184,0.06)', border: 'rgba(148,163,184,0.22)' },
  { emoji: '🏆', color: '#fbbf24', bg: 'rgba(251,191,36,0.06)',  border: 'rgba(251,191,36,0.22)'  },
  { emoji: '📈', color: '#34d399', bg: 'rgba(52,211,153,0.05)',  border: 'rgba(52,211,153,0.20)'  },
  { emoji: '⚖️', color: '#60a5fa', bg: 'rgba(96,165,250,0.06)',  border: 'rgba(96,165,250,0.22)'  },
  { emoji: '1️⃣', color: '#38bdf8', bg: 'rgba(56,189,248,0.05)',  border: 'rgba(56,189,248,0.18)'  },
  { emoji: '🔑', color: '#f59e0b', bg: 'rgba(245,158,11,0.05)',  border: 'rgba(245,158,11,0.18)'  },
];

export function detectCalloutStyle(text) {
  if (!text || typeof text !== 'string') return null;
  return CALLOUT_MAP.find(c => text.startsWith(c.emoji)) ?? null;
}

export const AthenaCallout = React.memo(function AthenaCallout({ children, color, bg, border }) {
  return (
    <div style={{
      background: bg,
      border: `1px solid ${border}`,
      borderLeft: `3px solid ${color}`,
      borderRadius: 8,
      padding: '10px 14px',
      margin: '8px 0',
      color: 'rgba(220,228,255,0.92)',
      fontSize: 13,
      lineHeight: 1.65,
    }}>
      {children}
    </div>
  );
});
